import axios from 'axios';
import { useSession } from 'next-auth/react';
import React from 'react';

import {
  clearPendingAwsExternalId,
  readPendingAwsExternalId,
} from '@/hooks/cloudPricing/pendingAwsConnection';
import { useClaimAwsConnection } from '@/hooks/cloudPricing/useAwsConnections';

export function useClaimPendingAwsConnection() {
  const { data: session, status } = useSession();
  const claim = useClaimAwsConnection();
  const inFlightRef = React.useRef(false);

  React.useEffect(() => {
    if (status !== 'authenticated') return;
    if (!session?.user?.tenant_id) return;
    const externalId = readPendingAwsExternalId();
    if (!externalId || inFlightRef.current) return;

    inFlightRef.current = true;
    void claim
      .mutateAsync(externalId)
      .then(() => {
        clearPendingAwsExternalId();
      })
      .catch((error) => {
        const statusCode = axios.isAxiosError(error) ? error.response?.status : undefined;
        if (statusCode === 403 || statusCode === 400 || statusCode === 404) {
          clearPendingAwsExternalId();
          return;
        }
        inFlightRef.current = false;
      });
  }, [claim, session?.user?.tenant_id, status]);
}

